export const objectCountry = Object.freeze({
  CLP: {
    locale: "es-CL",
    prefix: "+56",
    currency: "CLP",
    country: "CL",
    name: "Chile",
    locationRestriction: {
      rectangle: {
        low: {
          latitude: -56.0,
          longitude: -75.0,
        },
        high: {
          latitude: -17.0,
          longitude: -66.0,
        },
      },
    },
    defaultGeolocation: { lat: -33.456205, lng: -70.666362 } // Santiago
  },
  COP: {
    locale: "es-CO",
    prefix: "+57",
    currency: "COP",
    country: "CO",
    name: "Colombia",
    locationRestriction: {
      rectangle: {
        low: {
          latitude: -4.0, // Punto más al sur (Amazonas)
          longitude: -79.0, // Punto más al oeste (Costa Pacífica)
        },
        high: {
          latitude: 12.0, // Punto más al norte (Punta Gallinas)
          longitude: -66.0, // Punto más al este (Límite con Venezuela)
        },
      },
    },
    defaultGeolocation: { lat: 4.711, lng: -74.0721 }, // Bogotá
  },
  PEN: {
    locale: "es-PE",
    prefix: "+51",
    currency: "S/",
    country: "PE",
    name: "Perú",
    locationRestriction: {
      rectangle: {
        low: {
          latitude: -18.0, // Punto más al sur (Tacna)
          longitude: -81.0, // Punto más al oeste (Costa Pacífica)
        },
        high: {
          latitude: 0.0, // Punto más al norte (Loreto)
          longitude: -68.0, // Punto más al este (Madre de Dios)
        },
      },
    },
    defaultGeolocation: { lat: -12.0464, lng: -77.0428 }, // Lima
  },
  MXN: {
    locale: "es-MX",
    prefix: "+52",
    currency: "MXN",
    country: "MX",
    name: "México",
    locationRestriction: {
      rectangle: {
        low: {
          latitude: 14.0, // Punto más al sur (Chiapas)
          longitude: -118.0, // Punto más al oeste (Baja California)
        },
        high: {
          latitude: 32.0, // Punto más al norte (Frontera con EE.UU.)
          longitude: -86.0, // Punto más al este (Yucatán)
        },
      },
    },
    defaultGeolocation: { lat: 19.4326, lng: -99.1332 }, // Ciudad de México
  },
});
